export default __webpack_public_path__ + "static/media/Management-white-db.38000410.svg";